export default __webpack_public_path__ + "static/media/loading.e97cfb52.gif";